import { PencilSquareIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Show } from 'components/shared/Show';
import React, { useState } from 'react';
import { IOrderTagData } from 'types/order/tags/IOrderTagData';
import { UpdateOrderTagForm } from './UpdateOrderTagForm';
import { RemoveOrderTagForm } from './RemoveOrderTagForm';
import { IHasTestData } from '../../../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../../../ui-toolkit/test-utilities/mergeTests';

const iconStyleClasses = 'flex-none w-4 h-4 cursor-pointer';

interface OrderTagItemProps extends IHasTestData {
  orderTag: IOrderTagData;
}

export const OrderTagItem: React.FC<OrderTagItemProps> = ({ orderTag, ...rest }) => {
  const [editTag, setEditTag] = useState<boolean>(false);
  const [deleteTag, setDeleteTag] = useState<boolean>(false);
  return (
    <div
      key={orderTag.tag.id}
      className="pt-2"
      data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item')}
      data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item')}
    >
      <div
        className={'flex gap-1'}
        data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item-label')}
        data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item-label')}
      >
        <p className={'flex-grow font-semibold'}>{orderTag.tag.label}</p>
        <Show
          when={editTag}
          fallback={
            <PencilSquareIcon
              onClick={() => setEditTag(true)}
              className={iconStyleClasses}
              data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item-edit-pencil')}
              data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item-edit-pencil')}
            />
          }
        >
          <TrashIcon
            onClick={() => setDeleteTag(true)}
            className={iconStyleClasses}
            data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item-trash')}
            data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item-trash')}
          />
          <XMarkIcon
            onClick={() => setEditTag(false)}
            className={iconStyleClasses}
            data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item-x-icon')}
            data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item-x-icon')}
          />
        </Show>
      </div>
      <Show
        when={editTag}
        fallback={
          <p
            className={'max-w-full whitespace-pre-line break-words'}
            data-test-id={mergeTests(rest['data-test-id'], 'order-tag-item-value')}
            data-test-class={mergeTests(rest['data-test-class'], 'order-tag-item-value')}
          >
            {orderTag.value}
          </p>
        }
      >
        <UpdateOrderTagForm orderTag={orderTag} setEditTag={setEditTag} />
      </Show>
      <RemoveOrderTagForm orderTag={orderTag} open={deleteTag} setOpen={setDeleteTag} />
    </div>
  );
};
